import { shallowRef } from 'vue';
import type { IDoesFilterPassParams, IRowNode } from 'ag-grid-enterprise';

export function useFilterStub<Value, FilterModel>(
  filterModelInstance: FilterModel,
  isFilterActive: (filterModel: FilterModel) => boolean,
  doesFilterPass: <T extends FilterModel>(filterModel: Exclude<T, null>, value: Value) => boolean
): {
  getModel(): FilterModel | null;
  setModel(model: FilterModel | null): void;
  isFilterActive(): boolean;
  doesFilterPass(
    this: {
      params: {
        getValue(node: IRowNode): Value;
      };
    },
    params: IDoesFilterPassParams
  ): boolean;
} {
  const filterModel = shallowRef<FilterModel | null>(filterModelInstance);

  return {
    getModel(): FilterModel | null {
      return filterModel.value;
    },

    setModel(model: FilterModel | null) {
      filterModel.value = model ?? null;
    },

    isFilterActive() {
      return filterModel.value !== null && isFilterActive(filterModel.value);
    },

    doesFilterPass(
      this: { params: { getValue(node: IRowNode): Value } },
      params: IDoesFilterPassParams
    ): boolean {
      if (!this.params || filterModel.value === null) return true;
      // Use getValue() to respect filterValueGetter, valueGetter, and field access
      const cellValue = this.params.getValue(params.node);
      return doesFilterPass(filterModel.value, cellValue);
    },
  };
}
